import React from "react";

/**
 * Inline centred spinner for page-level data-fetch loading states.
 * Uses the same teal brand colour as LoadingOverlay but renders in-flow
 * rather than as a fixed overlay.
 *
 * Usage:
 *   if (loading) return <PageLoader />;
 *   // or inline:
 *   {loading && <PageLoader message="Loading leaderboard…" />}
 */

const spinnerStyle = `
@keyframes cw-spin {
  to { transform: rotate(360deg); }
}
.cw-page-spinner {
  width: 38px;
  height: 38px;
  border: 4px solid rgba(80, 180, 200, 0.2);
  border-top-color: #50B4C8;
  border-radius: 50%;
  animation: cw-spin 0.75s linear infinite;
}
`;

export default function PageLoader({ message }) {
  return (
    <>
      <style>{spinnerStyle}</style>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "3rem 1rem",
          gap: "12px",
        }}
      >
        <div className="cw-page-spinner" />
        {message && (
          <span
            style={{
              fontSize: "0.9rem",
              color: "#50B4C8",
              fontFamily: "'Rubik', sans-serif",
              fontWeight: 500,
            }}
          >
            {message}
          </span>
        )}
      </div>
    </>
  );
}
